/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OneArgument } from "./OneArgument";

export class OneArgumentFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<OneArgument> {
    return super.deploy(overrides || {}) as Promise<OneArgument>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OneArgument {
    return super.attach(address) as OneArgument;
  }
  connect(signer: Signer): OneArgumentFactory {
    return super.connect(signer) as OneArgumentFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OneArgument {
    return new Contract(address, _abi, signerOrProvider) as OneArgument;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "argumentOne",
        type: "uint256",
      },
    ],
    name: "OneArgumentCalled",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "argumentOne",
        type: "uint256",
      },
    ],
    name: "oneArgument",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x6080604052348015600f57600080fd5b5060be8061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063c95cf0d814602d575b600080fd5b605660048036036020811015604157600080fd5b81019080803590602001909291905050506058565b005b807f29ab08c845830c69b55a1fba5c95718f65dc24361a471e3da14cd5ff2b37315960405160405180910390a25056fea2646970667358221220ab718beaaeec8ca7daa342e1ab33287ed86cb3e8697b6617e57b6ce639d5802b64736f6c63430006040033";
